import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Notes Icon
 *
 * @file Notes.jsx
 * @author Nivedhitha M
 */
const Notes = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 19 22" fill="none" {...props}>
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      fill="currentcolor"
      d="M1.00024 4.625V2C1.00024 0.895428 1.89567 0 3.00024 0H17.0002C18.0002 0
      19.0002 0.999998 19.0002 2V4V6V20C19.0002 21.1046 18.1048 22 17.0002 22L3.00024
      22C1.89567 22 1.00024 21.1046 1.00024 20V16.75H0.875244C0.391995 16.75 0.000244141
      16.3583 0.000244141 15.875C0.000244141 15.3918 0.391995 15 0.875244 15H1.00024V13.25H0.875244C0.391995
      13.25 0.000244141 12.8583 0.000244141 12.375C0.000244141 11.8918 0.391995 11.5 0.875244
      11.5H1.00024V9.75H0.875244C0.391995 9.75 0.000244141 9.35825 0.000244141 8.875C0.000244141
      8.39176 0.391995 8 0.875244 8H1.00024V6.375H0.875244C0.391995 6.375 0.000244141 5.98325 0.000244141
      5.5C0.000244141 5.01675 0.391995 4.625 0.875244 4.625H1.00024ZM9.82761 1.75H17.0007C17.0995 1.75 17.2507
      1.85181 17.2507 2V6.00001V20C17.2507 20.1381 17.1388 20.25 17.0007 20.25H7.75024V1.75H9.82761ZM6.00024
      1.75H3.00073C2.86265 1.75 2.75073 1.86193 2.75073 2L2.75068 4.625H3.62568C4.10893 4.625 4.50069 5.01675
      4.50069 5.5C4.50069 5.98325 4.10893 6.375 3.62568 6.375H2.75068L2.75072 8H3.62572C4.10897 8 4.50072 8.39175
      4.50072 8.875C4.50072 9.35825 4.10897 9.75 3.62572 9.75H2.75072L2.75073 11.5H3.62573C4.10897 11.5 4.50073
      11.8918 4.50073 12.375C4.50073 12.8583 4.10897 13.25 3.62573 13.25H2.75073V15H3.62573C4.10897 15 4.50073
      15.3918 4.50073 15.875C4.50073 16.3583 4.10897 16.75 3.62573 16.75H2.75073V20C2.75073 20.1381 2.86265 20.25
      3.00073 20.25H6.00024V1.75ZZ"
    />
  </SvgIcon>
);

export default Notes;
